import { useCallback } from "react";
import useLocalStorage from "@scripts/react/hooks/useLocalStorage";
import { migrateFromZustandStore } from "@rapid/utils/migrateFromZustandStore";

export enum WaitlistFeature {
    ContinuousImprovement = "continuous-improvement"
}

const STORAGE_KEY = "rapid-waitlist-state";
type WaitlistState = Record<string, Record<string, boolean>>;

migrateFromZustandStore(STORAGE_KEY, "joinedWaitlists");

export function useWaitlist() {
    const [waitlists, setWaitlists] = useLocalStorage<WaitlistState>(STORAGE_KEY, {});

    const hasJoinedWaitlist = useCallback(
        (userId: string | null, feature: WaitlistFeature | null) => {
            if (!userId || !feature) return false;
            return waitlists[userId]?.[feature] === true;
        },
        [waitlists]
    );

    const joinWaitlist = useCallback(
        (userId: string, feature: WaitlistFeature) => {
            setWaitlists((prev) => ({ ...prev, [userId]: { ...prev[userId], [feature]: true } }));
        },
        [setWaitlists]
    );

    const leaveWaitlist = useCallback(
        (userId: string, feature: WaitlistFeature) => {
            setWaitlists((prev) => {
                const userWaitlists = { ...prev[userId] };
                delete userWaitlists[feature];
                const updated = { ...prev };
                if (Object.keys(userWaitlists).length === 0) {
                    delete updated[userId];
                } else {
                    updated[userId] = userWaitlists;
                }
                return updated;
            });
        },
        [setWaitlists]
    );

    return { hasJoinedWaitlist, joinWaitlist, leaveWaitlist };
}
